var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestedQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06009 0.753906C5.74944 0.753906 5.49759 1.00575 5.49759 1.31641C5.49759 1.62706 5.74944 1.87891 6.06009 1.87891L11.8119 1.87891L0.412092 13.2788C0.188157 13.5026 0.188157 13.8657 0.412092 14.0897C0.636019 14.3136 0.999087 14.3136 1.22301 14.0897L12.6226 2.69009V8.44141C12.6226 8.75206 12.8744 9.00391 13.1851 9.00391C13.4957 9.00391 13.7476 8.75206 13.7476 8.44141V1.31641C13.7476 1.00575 13.4957 0.753906 13.1851 0.753906L6.06009 0.753906Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedQuestions);
export default __webpack_public_path__ + "static/media/suggested_questions.35bf7b7adf848d36d3b2f53fea2b0be8.svg";
export { ForwardRef as ReactComponent };